import { render, staticRenderFns } from "./tab.mpx?vue&type=template&id=40606e7b&isComponent&outputPath=components%2Ftab66c6e44b%2Findex"
import script from "./tab.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Ftab66c6e44b%2Findex"
export * from "./tab.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Ftab66c6e44b%2Findex"
import style0 from "./tab.mpx?vue&type=style&index=0&id=40606e7b&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_66c6e44b%22%7D&isComponent&outputPath=components%2Ftab66c6e44b%2Findex"


/* normalize component */
import normalizer from "!../../../../../example/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports